import { Toaster } from "sonner";
import { useTheme } from "@web/lib/theme";

/** Quiet toasts: bottom centre, no rich colours, short duration. */
export function Toasts() {
  const { resolved } = useTheme();
  return (
    <Toaster
      theme={resolved}
      position="bottom-center"
      duration={3500}
      visibleToasts={3}
      // Above the Dock on feed screens (it publishes --mm-dock-h) and the phone tab bar.
      offset={{ bottom: "calc(var(--mm-dock-h, 0px) + 24px)" }}
      mobileOffset={{ bottom: "calc(var(--mm-dock-h, 0px) + 72px)" }}
      toastOptions={{
        style: {
          background: "var(--paper)",
          color: "var(--ink)",
          border: "1px solid var(--line)",
          fontFamily: "var(--font-sans)",
        },
      }}
    />
  );
}
